import Select from 'domains/core/components/Select';
import { VoiceContentStateTypes } from 'pages/ContentVoiceBuilderPage/types';
import { setWaitTime } from 'pages/ContentVoiceBuilderPage/voiceCallActions';

type Props = {
    voiceContentState: VoiceContentStateTypes;
    dispatchVoiceContentAction: React.Dispatch<any>;
    isContentLoading: boolean;
};

const WaitTimeSelect = ({ dispatchVoiceContentAction, voiceContentState: state, isContentLoading }: Props) => (
    <Select
        disabled={isContentLoading}
        label="Wait Time"
        menuItemStyles={{ textTransform: 'none' }}
        onChange={(e: any) => dispatchVoiceContentAction(setWaitTime(e.target.value))}
        sx={{ width: '125px' }}
        type="string"
        value={state.voiceJson?.fallback?.waitTime}
        values={[
            { label: '2 secs', value: 2 },
            { label: '3 secs', value: 3 },
            { label: '4 secs', value: 4 },
            { label: '5 secs', value: 5 },
        ]}
    />
);

export default WaitTimeSelect;
